import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

export default function AdminRoute({ children }) {
  const { user } = useContext(UserContext);

  // Si no hay sesión iniciada, envía al login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Si no es Administrador (Rol 1), redirige al inicio
  const isAdmin = Number(user.idRol ?? user.id_rol) === 1;
  if (!isAdmin) {
    return <Navigate to="/home" replace />;
  }

  return children;
}